module.exports = __webpack_public_path__ + "static/media/poster-dovecotes.40db8426.jpg";